import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useAuth } from '../auth/AuthContext';
import AdComponent from './parts/AdComponent'

import SubmitComponent from './parts/submit';
import SubmitDetailComponent from './parts/submitdetail';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const Chatbot = () => {

  const { isLoggedIn, user, subscriptions } = useAuth();
  const isSubscribedToPlan = subscriptions.chatbotPremium || subscriptions.chatbotStandard;

  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [conversation, setConversation] = useState([]);
  const [typingIndex, setTypingIndex] = useState(0);
  const [currentMessage, setCurrentMessage] = useState('');
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  const [userInput, setUserInput] = useState('');
  const [showDetailComponent, setShowDetailComponent] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const token = localStorage.getItem('authToken');
  const fetchConversation = () => {
    setIsButtonClicked(true);
    setIsLoading(true);
    const apiBaseURL = process.env.REACT_APP_API_URL || 'https://hangul-match.com/';
    const apiUrl = `${apiBaseURL}api/generate-topic`;
    axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      setConversation(response.data.conversation);
      setIsLoading(false);
    })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          // エラーメッセージを表示するなど、特定の処理を行う
          console.error('Error message:', error.response.data.message);
          setErrorMessage(error.response.data.message);
          setIsLoading(false);
          setIsButtonClicked(false);
        } else {
          console.error('There has been a problem with your fetch operation:', error);
          setTimeout(() => {
            setErrorMessage('エラーが発生しております。何度も続く場合は、お問い合わせしてください。');
            setIsButtonClicked(false);
          }, 5000); 
        }
      });
  };
  function debounce(func, delay) {
    let timer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(context, args), delay);
    };
  }
  const debouncedFetchConversation = debounce(() => {
    fetchConversation();
  }, 300); // 300ミリ秒の遅延

  useEffect(() => {
    if (conversation.length > 0 && currentMessageIndex < conversation.length) {
      const message = conversation[currentMessageIndex];

      // 最初のユーザーメッセージをスキップ
      if (currentMessageIndex === 0 && message.role === 'user') {
        setCurrentMessageIndex(currentMessageIndex + 1);
        return;
      }

      // 2番目以降のメッセージに対してタイプライターアニメーションを適用
      if (typingIndex < message.content.length) {
        const timer = setTimeout(() => {
          setCurrentMessage(currentMessage + message.content[typingIndex]);
          setTypingIndex(typingIndex + 1);
        }, 50); // 50ミリ秒の遅延で文字を追加

        return () => clearTimeout(timer);
      } else {
        // 次のメッセージへ移行
        setCurrentMessageIndex(currentMessageIndex + 1);
        setTypingIndex(0);
        setCurrentMessage('');
      }
    }
  }, [conversation, currentMessageIndex, typingIndex, currentMessage]);

  // 3秒後にエラーメッセージをクリア
  setTimeout(() => {
    setErrorMessage('');
  }, 10000);

  return (
    <div className="HomeContainer">
      {errorMessage && (
        <Stack sx={{ width: '100%' }} spacing={2}>
          <Alert severity="error">{errorMessage}</Alert>
        </Stack>
      )}
      <div className="home">
        {!isButtonClicked && (
          <div className="HomeButtonStart">
            <Button
              variant="contained"
              onClick={debouncedFetchConversation}
              style={{
                background: '#21D65F',
                padding: '10px 20px',
                color: '#181818',
                fontSize: '1.1rem',
                fontWeight: 'bold',
              }}
            >
              添削を始める
            </Button>
          </div>
        )}

        {isButtonClicked && (
          <>
            {conversation && conversation.length > 0 && (
              <div className="conversation" style={{ marginBottom: '30px' }}>
                <h3>会話履歴:</h3>
                {conversation.slice(0, currentMessageIndex).map((message, index) => {
                  // 最初のメッセージで、かつそのメッセージがユーザーメッセージの場合はスキップする
                  if (index === 0 && message.role === 'user') {
                    return null;
                  }
                  return (
                    <div key={index}>
                      <p>
                        <strong>{message.role === 'user' ? 'あなた: ' : 'AI添削君: '}</strong>
                        {message.content}
                      </p>
                      {message.role === 'assistant' && <hr />}
                    </div>
                  );
                })}
                {/* 現在タイプ中のメッセージの表示 */}
                {currentMessageIndex < conversation.length && (
                  <p>
                    <strong>{conversation[currentMessageIndex].role === 'user' ? 'あなた: ' : 'AI添削君: '}</strong>
                    {currentMessage}
                  </p>
                )}
                {/* AI添削君からの最後のメッセージの後に広告を表示 */}
                {!isSubscribedToPlan && currentMessageIndex === conversation.length && (
                  <AdComponent />
                )}
              </div>
            )}

            {isLoading && <CircularProgress style={{ marginTop: '30px' }} />} {/* ローディングインジケータの表示 */}
            <div style={{ height: '1000px' }}></div>
            <div className="SubmitArea">

              {!showDetailComponent && (
                <>
                  <p style={{ textAlign: 'left' }}>{userInput.length}/200文字以内<small>かつ</small>韓国語のみ</p>
                <SubmitComponent
                  userInput={userInput}
                  setUserInput={setUserInput}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  conversation={conversation}
                  setConversation={setConversation}
                  setShowDetailComponent={setShowDetailComponent}
                    setErrorMessage={setErrorMessage}
                />
                </>
              )}

              {/* SubmitComponentのonChangeが発動したら表示 */}
              {showDetailComponent &&
                <SubmitDetailComponent
                  setIsLoading={setIsLoading}
                  conversation={conversation}
                  setConversation={setConversation}
                  setShowDetailComponent={setShowDetailComponent}
                  setErrorMessage={setErrorMessage}
                  setTypingIndex={setTypingIndex}
                  setCurrentMessage={setCurrentMessage}
                  setCurrentMessageIndex={setCurrentMessageIndex}
                />}
              <p style={{ textAlign: 'center', margin: '0px'  }}><small>韓国語の文字数カウントは正規の数字ではありません。</small></p>
              <p style={{ textAlign: 'center', margin: '0px' }}><small>ハングルマッチAIは間違える場合がございます。</small></p>
            </div>
          </>
        )}
      </div >
    </div>
  );
};

export default Chatbot;
